export function validateEmpty (value) {
  if (!value) {
    return '*Campo obrigatório'
  }

  return true
}

export function validateEmptyAndLength3 (value) {
  if (!value) {
    return '*Campo obrigatório'
  }

  if (value.length < 3) {
    return '*Este campo precisa de no mínimo 3 caracteres'
  }

  return true
}

export function validateEmptyAndEmail (value) {
  if (!value) {
    return '*Campo obrigatório'
  }

  const isValid = /^[a-z0-9.]+@[a-z0-9.]+\.[a-z]+?$/i.test(value)

  if (!isValid) {
    return '*Insira um e-mail válido'
  }

  return true
}
